// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"e_Ye","wrapperDark":"e_Ze","wrapperLight":"e__e","wrapperClosed":"e_0e","html":"e_1e"};